// Shown instead of an order screen for an app that has not approved Eat Recipe yet.
import { Link } from '../router';
import { Back } from '../icons';
import { useT } from '../i18n';

export function ComingSoon({ name, back }: { name: string; back: string }) {
  const t = useT();
  return (
    <div class="page">
      <div class="backbar"><Link href={back} class="icon-btn" aria-label={t('common.back')}><Back /></Link></div>
      <div class="card" style="margin:16px;padding:20px;display:flex;flex-direction:column;gap:10px">
        <span class="soon-badge" style="align-self:flex-start">{t('soon.badge')}</span>
        <h1 class="h2">{name}</h1>
        <p class="muted" style="margin:0;line-height:1.6">{t('soon.body', { app: name })}</p>
        <Link href={back} class="btn btn-outline">{t('common.back')}</Link>
      </div>
    </div>
  );
}
